export default "__VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__ 400w, __VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__ 560w";